import React from 'react';
import {
    FormRenderData,
    Language,
    Module,
    ModalSize,
    FilterSelectorValuesParams,
    FieldFValue,
    ScreenTypes,
} from '@cuatroochenta/co-admin-react-library';
import './res/scss/custom-styles.scss'
import '@cuatroochenta/co-admin-react-library/lib/index.css';
import {BulletinSelectionService} from './app/module/bulletin/view/BulletinSelectionService';
import {CustomButtonListBulletin} from './app/module/bulletin/view/component/CustomButtonListBulletin';
import {CustomButtonListSummary} from './app/module/bulletin/view/component/CustomButtonListSummary';
import {useBulletinListFilters} from './app/module/bulletin/view/useBulletinListFilters';
import {useSummaryListFilters} from './app/module/bulletin/view/useSummaryListFilters';

export const App = ({}): React.ReactElement => {

    const [showSelectsList, setShowSelectsList] = React.useState<boolean>(false);
    const bulletinListFiltersRef = useBulletinListFilters();
    const summaryListFiltersRef = useSummaryListFilters();
    const languages: Language[] = [
        {name: 'Español', code: 'es'},
    ];

    const beforeFormView = (entity: string, type: string, data: FormRenderData): React.ReactNode => {
        return null;
    };

    const afterList = (): React.ReactElement => {
        return <></>;
    };

    const afterFormView = (entity: string, type: string, data: FormRenderData): React.ReactNode => {
        return null;
    };

    const getSizeFilterModal = (entity: string): ModalSize | undefined => {
        if (entity === 'user') {
            return ModalSize.LG;
        }
    };

    const filterSelectorValues = (
        filterSelectorValuesParams: FilterSelectorValuesParams
    ): FieldFValue[] => {
        return filterSelectorValuesParams.values;
    }

    const customScreenButtonList = (entity: string, type: string, data: any): React.ReactNode => {
        setShowSelectsList(false);
        if (entity === 'bulletin') {
            if (type === ScreenTypes.LIST) {
                setShowSelectsList(true);
                return <CustomButtonListBulletin filtersRef={bulletinListFiltersRef} />;
            }
        }
        if (entity === 'summary') {
            if (type === ScreenTypes.LIST) {
                return <CustomButtonListSummary filtersRef={summaryListFiltersRef} />;
            }
        }
        return null;
    };

    const getSelectedIdsList = showSelectsList ?
        BulletinSelectionService.getSelectedIdsList : undefined;

    return (
        <Module
            actions={[]}
            afterFormView={afterFormView}
            beforeFormView={beforeFormView}
            afterList={afterList}
            locale={'es'}
            languages={languages}
            getSizeFilterModal={getSizeFilterModal}
            filterSelectorValues={filterSelectorValues}
            customScreenButtonList={customScreenButtonList}
            getSelectedIdsList={getSelectedIdsList}
        />
    );
}
